import {
  ActionIcon,
  Badge,
  Button,
  Divider,
  Group,
  Modal,
  Stack,
  Text,
  TextInput,
} from "@mantine/core"
import { UseFormReturnType } from "@mantine/form"
import { IconPlus, IconX } from "@tabler/icons-react"
import { useState } from "react"

import { VirtualDimensionsRequests } from "@costory/types/endpoints/virtualDimensions"

type Props = {
  form: UseFormReturnType<VirtualDimensionsRequests.EditVirtualDimension>
  isOpen: boolean
  onClose: () => void
}

export const DimensionValuesModal = ({ form, isOpen, onClose }: Props) => {
  const values = form.getValues().values
  const [val, setVal] = useState("")

  const handleAddValue = (v: string) => {
    const trimmedValue = v.trim()
    if (!values.includes(trimmedValue) && trimmedValue) {
      form.insertListItem("values", trimmedValue, 0)
      setVal("")
    }
  }

  const [isNextButtonDisabled, setIsNextButtonDisabled] = useState(false)
  const onCloseChange = () => {
    if (!isNextButtonDisabled) onClose()
  }
  return (
    <Modal
      size="xl"
      opened={isOpen}
      onClose={onCloseChange}
      title="Create a new Dimension"
    >
      <Group
        align="flex-start"
        wrap="nowrap"
        style={{
          borderTop: "1px solid var(--mantine-color-borderSubtle-0)",
        }}
        py={32}
      >
        <Stack gap={24} w="40%">
          <Stack gap={8}>
            <Text fw="bold">What is it for?</Text>
            <Text>
              Dimensions will be built thanks to the team work between your Tech
              & Finance champions. Build rules using SQL queries & shared cost
              breakdown to make you cloud cost meaningful.
            </Text>
          </Stack>
          <Stack gap={8}>
            <Badge>Dimension</Badge>
            <Text>
              1n axis to breakdown your cloud cost. You will probably have
              multiple dimensions. Common examples: Teams, Environment,
              Product_Lines...
            </Text>
          </Stack>
          <Stack gap={8}>
            <Badge>Dimension Values</Badge>
            <Text>
              The values that make sense for your org and you aim to report on
              to. The sum of your dimension values equal 100% of your cloud
            </Text>
          </Stack>
        </Stack>
        <Divider orientation="vertical" color="borderSubtle" />
        <Stack w="60%">
          <TextInput
            label="Write your own dimension name"
            {...form.getInputProps("name")}
            onKeyUp={(e) => {
              setIsNextButtonDisabled(!e.currentTarget.value.trim())
            }}
            data-intercom-target="costory-tour-vdim-dimension-name-input"
          />
          <Text fw="bold" mt={16}>
            Dimension values
          </Text>
          {values.map((value, index) => (
            <Group key={`value-${index}`} gap={8}>
              <TextInput
                disabled={true}
                {...form.getInputProps(`values.${index}`)}
                flex={1}
                value={value}
              />
              <ActionIcon
                color="textMuted"
                onClick={() => form.removeListItem("values", index)}
                data-intercom-target="costory-tour-vdim-remove-value"
              >
                <IconX />
              </ActionIcon>
            </Group>
          ))}
          <TextInput
            value={val}
            onChange={(v) => setVal(v.target.value)}
            onKeyDown={(value) => {
              if (value.type === "keydown" && value.key === "Enter") {
                handleAddValue(val)
              }
            }}
            flex={1}
            data-intercom-target="costory-tour-vdim-new-value-input"
          />
          <Button
            size="sm"
            variant="outline"
            leftSection={<IconPlus size={20} />}
            onClick={() => handleAddValue(val)}
            data-intercom-target="costory-tour-vdim-add-value-btn"
          >
            Add a value
          </Button>
        </Stack>
      </Group>
      <Group justify="flex-end">
        <Button
          disabled={isNextButtonDisabled}
          onClick={onClose}
          data-intercom-target="costory-tour-vdim-modal-next-btn"
        >
          Next
        </Button>
      </Group>
    </Modal>
  )
}
